import { readFromCache } from "@/utils/cache";

export default function () {
  return {
    locale: readFromCache("locale"),
  };
}
